export const menu = (nav, trigger) => {

  const navTrigger = document.querySelector(trigger);
  const navCnt = document.querySelector(nav);

  if (!nav || !trigger) {
    console.log(`Brak nawigacji '${nav}' i/lub triggera '${nav}'`);
    return;
  }

  function leaveMenu() {
    navTrigger.classList.remove('__jsActive');
    document.querySelector('.header').removeEventListener('mouseleave', leaveMenu);
  }

  navTrigger.addEventListener('click', (e) => {
    navTrigger.classList.toggle('__jsActive');
    if (navTrigger.classList.contains('__jsActive')) {
      setTimeout(() => {
        document.querySelector('.header').addEventListener('mouseleave', leaveMenu);
      }, 250);
    }
  });

  navCnt.querySelector('ul').addEventListener('click', () => {
    navTrigger.classList.toggle('__jsActive');
  });




};

export const menuMap = (mapList, trigger) => {
  
  //map__areas_more  - trigger

  
  const mapTrigger = document.querySelector(trigger);
  const mList = document.querySelector(mapList);

  if (!mList || !mapTrigger) {
    console.log(`Brak nawigacji '${mapList}' i/lub triggera '${mapList}'`);
    return;
  }

  mapTrigger.addEventListener('click', (e) => {
    if (mapTrigger.classList.contains('__jsActive')) {
      
      setTimeout(() => {
        mapTrigger.classList.toggle('__jsActive');
        document.querySelector('.map__areas ul').classList.add('__jsMore');
      }, 250);
    }
  });

}
